<template>
  <div class="app-container" v-loading="loading">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>

      <Title>基础信息（只读）</Title>
      <el-descriptions :column="3" border class="mt10">
        <el-descriptions-item label="子账号姓名">{{ info.childName }}</el-descriptions-item>
        <el-descriptions-item label="子账号手机号"><masked-phone :customer-id="info.childCustomerId" :followup-id="info.id" :masked="info.childPhoneMasked" /></el-descriptions-item>
        <el-descriptions-item label="身份等级">{{ info.identityLevel || '—' }}</el-descriptions-item>
        <el-descriptions-item label="主账号姓名">{{ info.parentName }}</el-descriptions-item>
        <el-descriptions-item label="主账号手机号"><masked-phone :customer-id="info.parentCustomerId" :followup-id="info.id" :masked="info.parentPhoneMasked" /></el-descriptions-item>
        <el-descriptions-item label="申请来源">{{ info.applySourceDesc || '—' }}</el-descriptions-item>
        <el-descriptions-item label="申请模块">{{ info.applyModule }}</el-descriptions-item>
        <el-descriptions-item label="所属大区">{{ info.regionName || '—' }}</el-descriptions-item>
        <el-descriptions-item label="省市区">{{ [info.provinceName, info.cityName, info.areaName].filter(i => i).join('') || '—' }}</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{ info.submitTime || '—' }}</el-descriptions-item>
        <el-descriptions-item label="审核通过时间">{{ info.auditTime || '—' }}</el-descriptions-item>
      </el-descriptions>

      <Title class="mt20">联系结果</Title>
      <el-form :model="form" ref="dataForm" label-width="140px" class="mt10">
        <el-form-item label="联系结果：" prop="contactResult" :rules="[{ required: true, message: '请选择联系结果', trigger: 'change' }]">
          <el-radio-group v-model="form.contactResult">
            <el-radio :label="1">已接通</el-radio>
            <el-radio :label="2">未接通</el-radio>
            <el-radio :label="3">无法联系</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="回访时间：" prop="visitTime" :rules="[{ required: true, message: '请选择回访时间', trigger: 'change' }]">
          <!-- REQ-2026-601171 #4：回访时间记的是"已经联系过"的时刻，不能填未来。
               这里只禁掉今天之后的**日期**（Element 的 picker-options 粒度就到天），
               今天之内选了未来的几分钟仍然拦不住 —— 真正生效的是后端那道
               assertVisitTimeNotFuture，前端这道只是少让用户白填一次。 -->
          <el-date-picker
            v-model="form.visitTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择回访时间"
            :picker-options="visitTimePickerOptions"
          />
        </el-form-item>

        <!-- 未接通 / 无法联系：必填下次跟进时间 + 备注，任务保持待回访 -->
        <template v-if="form.contactResult === 2 || form.contactResult === 3">
          <el-form-item label="下次跟进时间：" prop="nextFollowAt" :rules="[{ required: true, message: '请选择下次跟进时间', trigger: 'change' }]">
            <el-date-picker v-model="form.nextFollowAt" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择下次跟进时间" />
          </el-form-item>
          <el-form-item label="备注：" prop="note" :rules="[{ required: true, message: '请填写备注', trigger: 'blur' }]">
            <el-input v-model="form.note" type="textarea" :rows="3" placeholder="请填写未接通/无法联系的说明" style="width:500px" />
          </el-form-item>
        </template>

        <!-- 已接通：身份核实四项 -->
        <template v-if="form.contactResult === 1">
          <Title class="mt10">身份核实</Title>
          <el-form-item v-for="q in identityQuestions" :key="q.key" :label="q.label + '：'" :prop="q.key"
                        :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
            <el-radio-group v-model="form[q.key]">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
            <span v-if="form[q.key] === 0" class="abnormal-hint">{{ q.hint }}</span>
          </el-form-item>

          <Title class="mt10">核实结果</Title>
          <el-form-item label="核实结果：" prop="verifyResult" :rules="[{ required: true, message: '请选择核实结果', trigger: 'change' }]">
            <el-radio-group v-model="form.verifyResult">
              <el-radio :label="1">正常</el-radio>
              <el-radio :label="2">异常</el-radio>
            </el-radio-group>
          </el-form-item>

          <template v-if="form.verifyResult === 1">
            <el-form-item label="跟进反馈：" prop="feedback" :rules="[{ required: true, message: '请填写跟进反馈', trigger: 'blur' }]">
              <el-input v-model="form.feedback" type="textarea" :rows="3" placeholder="请填写跟进反馈" style="width:500px" />
            </el-form-item>
          </template>

          <template v-if="form.verifyResult === 2">
            <el-form-item label="异常类型：" prop="abnormalTypes" :rules="[{ required: true, type: 'array', min: 1, message: '请至少选择一项异常类型', trigger: 'change' }]">
              <el-checkbox-group v-model="form.abnormalTypes">
                <el-checkbox v-for="t in abnormalTypeOptions" :key="t.value" :label="t.value">{{ t.label }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="反馈说明：" prop="feedback" :rules="[{ required: true, message: '请填写反馈说明', trigger: 'blur' }]">
              <el-input v-model="form.feedback" type="textarea" :rows="3" placeholder="请填写异常说明" style="width:500px" />
            </el-form-item>
            <el-form-item label="凭证：" prop="evidenceUrls">
              <el-upload
                :action="uploadUrl"
                list-type="picture-card"
                :file-list="evidenceList"
                :before-upload="beforeEvidenceUpload"
                :on-success="handleEvidenceUpload"
                :on-remove="handleEvidenceRemove"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="upload-tip">支持 JPG/PNG，单张不超过 10MB</div>
            </el-form-item>
            <el-form-item prop="confirmed" :rules="[{ validator: validateConfirm, trigger: 'change' }]">
              <el-checkbox v-model="form.confirmed">我已核实以上信息真实准确，确认提交</el-checkbox>
            </el-form-item>
          </template>
        </template>

        <el-form-item>
          <el-button @click="handleSaveDraft" :loading="draftLoading">保存草稿</el-button>
          <el-button type="primary" @click="handleSubmit" :loading="submitLoading">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import childFollowupApi from '@/api/cust/childFollowup'
import MaskedPhone from './components/MaskedPhone.vue'

const IDENTITY_QUESTIONS = [
  { key: 'qSelfApply', label: '是否本人申请', hint: '异常：非本人申请' },
  { key: 'qPhoneMatch', label: '手机号与资料一致', hint: '异常：手机号与资料不一致' },
  { key: 'qKnowPurpose', label: '是否知晓用途', hint: '异常：本人不知情/不清楚用途' },
  { key: 'qRelationTrue', label: '关系是否属实', hint: '异常：关系不属实' }
]

const ABNORMAL_TYPE_OPTIONS = [
  { value: 1, label: '本人不知情' },
  { value: 2, label: '非本人申请' },
  { value: 3, label: '资料不一致' },
  { value: 4, label: '手机号不一致' },
  { value: 5, label: '身份信息异常' },
  { value: 6, label: '申请目的异常' },
  { value: 7, label: '关系不属实' },
  { value: 8, label: '其他' }
]

function initFormBean() {
  return {
    contactResult: null,
    visitTime: null,
    nextFollowAt: null,
    note: '',
    qSelfApply: null,
    qPhoneMatch: null,
    qKnowPurpose: null,
    qRelationTrue: null,
    verifyResult: null,
    feedback: '',
    abnormalTypes: [],
    evidenceUrls: [],
    confirmed: false
  }
}

export default {
  name: 'SubaccountFollowupVisit',
  components: { MaskedPhone },
  props: ['rowId'],
  data() {
    return {
      loading: false,
      draftLoading: false,
      submitLoading: false,
      info: {},
      form: initFormBean(),
      identityQuestions: IDENTITY_QUESTIONS,
      abnormalTypeOptions: ABNORMAL_TYPE_OPTIONS,
      evidenceList: [],
      // REQ-2026-601171 #4：禁掉今天之后的日期，回访时间不能填未来。
      // disabledDate 的粒度只到「天」，同一天内的未来时刻它拦不住，
      // 真正生效的是后端 assertVisitTimeNotFuture。
      visitTimePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload'
    }
  },
  created() {
    this.loadDetail()
  },
  methods: {
    loadDetail() {
      this.loading = true
      childFollowupApi.fetchById(this.rowId)
        .then(({ data }) => {
          this.info = data || {}
          // 有草稿则回填草稿内容，支持继续编辑。
          // ⚠️ 后端的 draft 是**JSON 字符串**（库里存的就是一段 JSON 文本），不是对象。
          //    直接 {...this.form, ...data.draft} 会把字符串按字符展开成 0/1/2… 一堆乱键，表单一个字段都回填不上
          const draft = this.parseDraft(data && data.draft)
          if (draft) {
            const blank = initFormBean()
            // 只回填表单认识的字段：草稿里混进来的别的键（历史版本留下的）不带进提交
            Object.keys(blank).forEach(k => {
              if (draft[k] !== undefined && draft[k] !== null) this.form[k] = draft[k]
            })
            this.evidenceList = (this.form.evidenceUrls || []).map(url => ({ url }))
          }
        })
        .finally(() => { this.loading = false })
    },
    validateConfirm(rule, value, callback) {
      if (this.form.verifyResult === 2 && !this.form.confirmed) {
        return callback(new Error('请勾选确认后再提交'))
      }
      callback()
    },
    beforeEvidenceUpload(file) {
      const isImage = ['image/jpeg', 'image/png'].includes(file.type)
      const isLt10M = file.size / 1024 / 1024 <= 10
      if (!isImage) {
        this.$message.error('凭证只支持 JPG/PNG 格式')
      }
      if (!isLt10M) {
        this.$message.error('凭证单张不能超过 10MB')
      }
      return isImage && isLt10M
    },
    handleEvidenceUpload(response, file) {
      if (file && file.response) {
        this.evidenceList.push({ url: file.response.data })
        this.form.evidenceUrls.push(file.response.data)
      }
    },
    handleEvidenceRemove(file) {
      this.evidenceList = this.evidenceList.filter(i => i.url !== file.url)
      this.form.evidenceUrls = this.evidenceList.map(i => i.url)
    },
    parseDraft(raw) {
      if (!raw) return null
      if (typeof raw === 'object') return raw
      try {
        const obj = JSON.parse(raw)
        return obj && typeof obj === 'object' ? obj : null
      } catch (e) {
        return null
      }
    },
    /**
     * 提交体 —— 字段名与取值**严格按后端 CustomerChildFollowupSubmitDTO**：
     *   id          回访任务 id（@NotNull）。原来传的是 followupId，后端不认
     *   version     乐观锁版本号（@NotNull），取详情接口返回的那个。原来没传
     *   submitType  1 未接通/无法联系  2 已接通+核实正常  3 已接通+核实异常（@NotNull，数字）。
     *               原来传的是 type: 'noContact' | 'normal' | 'abnormal' —— 名字和类型都不对
     * 三个都是 @NotNull：原来那种传法，**每一次提交都会被参数校验直接拒掉**。
     * verifyResult 只是页面上用来切表单的，后端由 submitType 决定结果，不收这个字段，所以不传。
     */
    buildSubmitData() {
      let submitType = 1
      if (this.form.contactResult === 1) {
        submitType = this.form.verifyResult === 2 ? 3 : 2
      }
      const { verifyResult, ...rest } = this.form
      return { ...rest, id: this.rowId, version: this.info.version, submitType }
    },
    handleSaveDraft() {
      this.draftLoading = true
      // 草稿接口的入参是 { id, draft }，draft 原样存成 JSON；不是把表单摊平了传
      childFollowupApi.saveDraft({ id: this.rowId, draft: { ...this.form } })
        .then(() => {
          this.$common.showNotify('success', '成功', '草稿已保存')
        })
        .catch((error) => this.$common.showNotifyError(error))
        .finally(() => { this.draftLoading = false })
    },
    handleSubmit() {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) return
        this.$common.confirm('确认提交本次回访结果？').then(() => {
          this.submitLoading = true
          return childFollowupApi.submit(this.buildSubmitData())
            .then(() => {
              this.$common.showNotify('success', '成功', '提交成功')
              this.handleBack()
            })
            .catch((error) => this.$common.showNotifyError(error))
            .finally(() => { this.submitLoading = false })
        }).catch(() => {})
      })
    },
    handleBack() {
      this.$emit('handleShow', '', 'list')
    }
  }
}
</script>

<style lang="scss" scoped>
.abnormal-hint {
  margin-left: 10px;
  color: #e73f3f;
  font-size: 12px;
}
.upload-tip {
  color: #909399;
  font-size: 12px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
</style>
